module.exports = __webpack_public_path__ + "static/media/profile-2user.810bd41c.svg";